export enum TravellerType {
  DigitalNomad = 'Digital Nomad',
  Luxury = 'Luxury',
  Foodie = 'Foodie',
  Adventure = 'Adventure',
  Culture = 'Culture',
  Creator = 'Creator',
  Wellness = 'Wellness'
}
